import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TileSet } from '../../tile-set-type-select/models/tile-set.model';
import { addDashboardTileFeatureKey, State } from './add-dashboard-tile.reducer';

export const addDashboardTileFeature = createFeatureSelector<State>(addDashboardTileFeatureKey);

export const selectCallState = createSelector(addDashboardTileFeature, (state) => {
   return state.callState;
});

export const selectAllTileSets = createSelector(addDashboardTileFeature, (state) => {
   return state.tileSets;
});

export const selectSearchText = createSelector(addDashboardTileFeature, (state) => {
   return state.searchText;
});

// export const selectCustomTileSet = createSelector(selectAllTileSets, (tileSets) => {
//    return tileSets?.find((tileSet) => tileSet.tileSetId === TileSets.Custom) ?? null;
// });

export const selectLastAddedDashboardTileId = createSelector(addDashboardTileFeature, (state) => {
   return state.lastAddedDashboardTileId;
});

export const selectDesignerTileSets = createSelector(selectAllTileSets, (tileSets) => {
   // TODO: remove filtering off of announcements once requirements for tile are more fleshed out
   // See comments on https://jira.lcs.com/browse/QMG-6412
   return tileSets ?? [];
});

export const selectFilteredTileSets = createSelector(
   selectSearchText,
   selectDesignerTileSets,
   (searchText: string | null, designerTileSets: TileSet[]) => {
      return designerTileSets.filter(
         (tileSet) => !searchText || tileSet.description?.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())
      );
   }
);
